import { MessageSquare, X } from "lucide-react";
import { UnavailableButton } from "./UnavailableButton";
import { UnavailableIconButton } from "./UnavailableIconButton";

/** The concept's Reject and Add to chat actions, shown but not wired up. */
export const ReviewActionPlaceholders = ({
  showReject,
  compact = false,
}: {
  showReject: boolean;
  compact?: boolean;
}) =>
  compact ? (
    <span className="flex items-center">
      {showReject && (
        <UnavailableIconButton label="Reject" color="error">
          <X size={14} />
        </UnavailableIconButton>
      )}
      <UnavailableIconButton label="Add to chat">
        <MessageSquare size={14} />
      </UnavailableIconButton>
    </span>
  ) : (
    <span className="flex flex-wrap items-center gap-1">
      {showReject && (
        <UnavailableButton color="error" startIcon={<X size={14} />}>
          Reject
        </UnavailableButton>
      )}
      <UnavailableButton startIcon={<MessageSquare size={14} />}>
        Add to chat
      </UnavailableButton>
    </span>
  );
